

module.exports = __webpack_require__.stylable.create(
    "OptionsDropdown3447037927",
    {"classes":{"root":"OptionsDropdown3447037927__root"},"vars":{},"stVars":{"dropdownHeight":"40px","backgroundColor":"#fff","borderColor":"silver","borderWidth":"1px","inputColor":"rgb(68, 68, 68)","optionTextColor":"#333","disabledOptionTextColor":"rgba(51, 51, 51, 0.6)","productOptionsFont":"'\"fallback(font(--productPage_optionsFontStyle), font(--quickView_qtyAndOptionsFontStyle), font({theme: 'Body-M', size: '15px'}))\"'","productLabelFont":"'\"fallback(font(--productPage_optionsFontStyle), font(--quickView_qtyAndOptionsFontStyle), font({theme: 'Body-M', size: '14px'}))\"'","productLabelColor":"'\"fallback(color(--productPage_optionsColor), color(--quickView_qtyAndOptionsColor), color(color-5))\"'"},"keyframes":{}},
    "",
    19,
    "OptionsDropdown3447037927",
    null
);
